/* eslint-disable import/no-default-export */
import createLocationSuggestion from './createLocationSuggestion';

interface Suggestion {
  text: string;
  id: string;
}

const mockSuggestions: Suggestion[] = [
  {
    id: 'location:ec9c1b49-8ac2-3cb6-b120-b1718fb09ed0',
    text: 'Singapore',
  },
  {
    id: 'location:3ce3e6de-f61b-3d19-8c16-c7e9bcdfcf87',
    text: 'Sembawang Estate',
  },
  {
    id: 'location:66d7a4eb-23cb-3533-b7a0-db5e9caaeade',
    text: 'Sengkang New Town',
  },
  {
    id: 'location:1b5c328a-3131-3474-ac89-40fc80cc5dc9',
    text: 'Seletar',
  },
  {
    id: 'location:3941da58-a28b-3f35-821d-aa46089280d8',
    text: 'Marina South',
  },
];

const getSuggestions = (keyword: string) =>
  mockSuggestions
    .filter(
      ({ text }) =>
        text.toLowerCase().lastIndexOf(keyword.toLowerCase(), 0) === 0,
    )
    .map((suggestion) => createLocationSuggestion(keyword, suggestion));

export default () => ({
  suggestions: (...args: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const [, , , { variableValues }] = args;
    const { keyword } = variableValues as Record<string, string>;

    return keyword.length === 0 ? [] : getSuggestions(keyword);
  },
});
